export const getQuizSetsUrl = () => {
    return `/set?status=complete`
}

export const getActiveQuestionUrl = roomName => {
    return `/${roomName}/quiz`
}
